import {createFeatureSelector, createSelector} from '@ngrx/store';
import {GlobalConfigState} from './global-config.reducer';

export const selectGlobalConfigState = createFeatureSelector<GlobalConfigState>('globalConfig');

export const selectGlobalConfig = createSelector(
  selectGlobalConfigState,
  (state) => state.config
);

export const selectPubmedLocalEnabled = createSelector(
  selectGlobalConfigState,
  (state) => state.config?.pubmedLocalEnabled ?? false
);
